import { applications } from "../../data";
import { BottomNav } from "./ClientNav";
import { useNavigate } from "react-router-dom";

const INSTALLED = ["ru.corp.mail", "ru.corp.vcs", "ru.corp.market", "ru.corp.security", "ru.corp.docs"];

export default function InstalledPage() {
  const navigate = useNavigate();
  const list = applications.filter((a) => INSTALLED.includes(a.pkg));
  return (
    <div className="flex h-full flex-col">
      <header className="px-4 pb-2 pt-2">
        <h1 className="text-[22px] font-semibold tracking-[-0.01em] text-[var(--color-fg)]">Установленные</h1>
        <div className="mt-0.5 text-[12px] text-[var(--color-fg-muted)]">{list.length} приложений</div>
      </header>

      <div className="flex-1 overflow-y-auto px-2 pb-4">
        <ul className="flex flex-col">
          {list.map((a, i) => (
            <li key={a.pkg} style={{ animationDelay: `${i * 35}ms` }} className="stagger-up flex items-center gap-3 rounded-xl px-2 py-2.5 hover:bg-[var(--color-surface-2)]">
              <span
                className="grid h-11 w-11 shrink-0 place-items-center rounded-2xl font-semibold text-white"
                style={{ background: a.iconColor, fontSize: 18 }}
              >
                {a.iconLetter}
              </span>
              <div className="min-w-0 flex-1">
                <div className="truncate text-[14px] font-medium text-[var(--color-fg)]">{a.name}</div>
                <div className="truncate font-mono text-[11px] text-[var(--color-fg-muted)]">{a.pkg} · {a.version}</div>
              </div>
              <button
                onClick={() => navigate(`/client/app/${encodeURIComponent(a.pkg)}`)}
                className="shrink-0 rounded-full border border-[var(--color-border-strong)] px-3 py-1.5 text-[12px] font-medium text-[var(--color-fg)] hover:bg-[var(--color-surface-2)]"
              >
                Открыть
              </button>
            </li>
          ))}
        </ul>
      </div>

      <BottomNav />
    </div>
  );
}
